import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_28: FaireProductEntity = {
  token: "starter_collection_28",
  type: "product",
  name: "Rhubarb Oven Mitt",
  brandName: "Hedley & Bennett",
  imageUrl: "",
  priceDollars: 35,
  msrpDollars: 70,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
